import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash-es';

@Pipe({ name: 'hyperLink' })
export class HyperLinkPipe implements PipeTransform {
  transform(companyUrl: string): string {
    if (companyUrl == null || companyUrl == undefined || companyUrl == '') {
      return companyUrl;
    } else {
      const isHttp = _.startsWith(companyUrl, 'http:') || _.startsWith(companyUrl, 'https:');
      return isHttp ? companyUrl : '//' + companyUrl;
    }
  }
}
